import React from 'react';
import { DatePicker, Space } from 'antd';
import styled from 'styled-components';

const StyledDatePicker = styled(DatePicker)`
  width: 352px;
  height: 40px;
  font-size: 16px;
  border-radius: 4px;
  transition: border-color 0.3s ease;

  &:hover {
    border-color: #ee0434;
  }

  &.ant-picker-focused {
    border-color: #ee0434;
  }

  .ant-picker-input > input {
    height: 100%;
    line-height: 40px;
  }
`;

const DateTimeAntd = ({showTime, format, dateTime, onChange, onOk }) => {
  return (
    <Space direction="vertical" size={12}>
      <StyledDatePicker
        showTime = {showTime}
        format={format}
        value={dateTime}
        onChange={onChange}
        onOk={onOk}
        placeholder="Chọn thời gian"
      />
    </Space>
  );
};

export default React.memo(DateTimeAntd);
